import React from "react";

import { connect } from "react-redux";

import { Icon, Header } from "semantic-ui-react";

import SetupView from "./transactions/SetupView";
import RecentTransactionsView from "./transactions/RecentTransactionsView";

const TransactionsView = props => {
  return (
    <div>
      <Header as="h2">
        <Icon name="university" />
        <Header.Content>
          Bank Transactions
          <Header.Subheader>
            Reconcile spending on your accounts.
          </Header.Subheader>
        </Header.Content>
      </Header>
      {!props.bankConnected && <SetupView />}
      {props.bankConnected && <RecentTransactionsView />}
    </div>
  );
};

const mapStateToProps = state => ({
  bankConnected: state.transactions.plaid_connected
});

export default connect(mapStateToProps)(TransactionsView);



// WEBPACK FOOTER //
// ./frontend/src/views/pages/TransactionsView.js